import _extends from 'babel-runtime/helpers/extends';
export default function resultAdapter() {
    var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return _extends(_extends({}, response), { retCode: response.retCode === '00000' ? '000000' : response.retCode, retInfo: response.retInfo, retData: response.retData === undefined ? response.data : response.retData });
}